// extracted by mini-css-extract-plugin
export default {"dayTable":"calendar-daily-view_dayTable__Fnjno","stickyHeader":"calendar-daily-view_stickyHeader__Vxt1s"};